import { Checkbox, Col, Form } from 'antd'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import Drawer from 'components/Drawer'
import Label from 'components/Label/Label'
import RichEditor from 'components/RichEditor/index'
import {
  BoldHeading,
  Heading,
} from 'modules/Onboarding/Partials/Corporates/Partials/CorporateInfoTable/VerifyCorporateDrawer/style.js'
import {
  FormItem,
  FormWrapper,
} from 'modules/Onboarding/Partials/Corporates/Register/CorporateInfo/style'
import { PaddingDetails } from 'modules/Onboarding/Partials/Institutes/Partials/InstituteInfoTable/VerifyInstituteDrawer/style'
import { FlexWrap } from 'modules/Onboarding/Partials/Institutes/Partials/InstituteInfoTable/ViewInstituteDrawer/Style/style'
import { InstituteRequestforChange } from 'modules/Onboarding/Partials/Institutes/Partials/InstituteInfoTable/actions'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CONSTANTS from 'utils/constants'

const ChangeInstituteDetails = ({
  changeInstituteDetails,
  setChangeInstituteDetails,
  setRequestSentDrawer,
}) => {
  const dispatch = useDispatch()

  const [form] = Form.useForm()

  const singleInstituteData = useSelector(
    state => state?.InstituteOnboarding?.singleInstituteData
  )
  const initialFormValue = {
    instituteRequestToChange: [],
    reason: '',
  }
  const [formValue, setFormValue] = useState(initialFormValue)
  useEffect(() => {
    singleInstituteData?.addReason &&
      onChangeReason(singleInstituteData?.addReason)
  }, [singleInstituteData])
  const addReason = Form.useWatch('addReason', form)

  const onChangeReason = reason => {
    const result = reason

    if (!result) {
      form.setFieldsValue({ addReason: '' })
    } else {
      form.setFieldsValue({ addReason: reason })
    }
    setFormValue({ ...formValue, reason: reason })
  }

  const onChange = checkedValues => {
    if (checkedValues.length) {
      form.setFieldsValue({ needToChange: checkedValues })
    } else {
      form.setFieldsValue({ needToChange: '' })
    }
    setFormValue({ ...formValue, instituteRequestToChange: checkedValues })
  }
  const onSubmit = () => {
    const reqData = {
      reason: addReason?.replace(/<[^>]*>?/gm, ''),
      needToChange: formValue.instituteRequestToChange,
      journeyType: 'INSTITUTE',
    }
    let payLoad = { ...reqData }
    const callBack = () => {
      setChangeInstituteDetails(false)
      setRequestSentDrawer(true)
      form.resetFields()
      setFormValue(initialFormValue)
    }
    dispatch(
      InstituteRequestforChange(singleInstituteData?.id, payLoad, callBack)
    )
  }

  const content = () => {
    return (
      <Fragment>
        <Heading>
          Request <BoldHeading>{singleInstituteData?.name}</BoldHeading> to
          docdcsd the changes in onboarding form{' '}
        </Heading>

        <PaddingDetails />

        <FormItem
          name={'needToChange'}
          rules={[
            {
              required: true,
              message: 'Please select a change fields!',
            },
          ]}
          id={'instituteRequestToChange'}
        >
          <Checkbox.Group
            style={{ width: '100%' }}
            value={formValue.instituteRequestToChange}
            onChange={onChange}
          >
            <Col>
              <Col>
                <Checkbox value="Authorized Signatory">
                  {'Authorized Signatory'}
                </Checkbox>
              </Col>
              <Col>
                <Checkbox value="Contract">{'Contract'}</Checkbox>
              </Col>
              <Col>
                <Checkbox value="Institute Details">
                  {'Institute Details'}
                </Checkbox>
              </Col>
            </Col>
          </Checkbox.Group>
        </FormItem>
        <PaddingDetails />
        <Control top="20px" flexStart column width="500px">
          <Label>Add Reason</Label>
          <FormItem
            name={'addReason'}
            rules={[
              {
                required: true,
                message: CONSTANTS.ERROR_MESSAGE.REQ_INPUT('reason'),
              },
            ]}
          >
            <RichEditor
              value={formValue.reason}
              onChange={onChangeReason}
              placeholder={'Enter Your Reason here'}
            />
          </FormItem>
        </Control>
      </Fragment>
    )
  }

  const onClose = () => {
    setChangeInstituteDetails(false)
  }

  const back = () => {
    setChangeInstituteDetails(false)
    setFormValue(initialFormValue)
    form.setFieldsValue({ needToChange: [], addReason: '' })
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Secondary text="Back" onClick={back} height="38px" />
        <Button.Primary
          type="submit"
          htmlType="submit"
          form={'instituteRequestToChange'}
          text="Confirm"
          height="38px"
        />
      </FlexWrap>
    )
  }

  return (
    <FormWrapper
      scrollToFirstError
      onFinish={onSubmit}
      id={'instituteRequestToChange'}
      form={form}
      layout="vertical"
    >
      <Drawer
        width="40%"
        title={'Request to Change'}
        placement="right"
        padding="30px"
        headermargin="0 30px"
        headerpadding="16px 0"
        closable
        onClose={onClose}
        visible={changeInstituteDetails}
        content={content()}
        footer={footer()}
      />
    </FormWrapper>
  )
}

export default ChangeInstituteDetails
